// constants
import { managementZonesTypes } from 'constants/scripts';

// selectors
import { getActivityCategoriesByActivityType} from 'activities/selectors';
import { getProductYearForScript } from 'scripts/selectors';
import { getActiveFieldId } from 'current/selectors';
import { getApplicationScriptsForFieldId } from 'scripts/application-selectors';


export const getApplicationManagementZones = (state) => {
  const scripts = getApplicationScriptsForFieldId(state, getActiveFieldId(state));
  if (Object.keys(scripts).length === 0) {
    return [];
  }
  const displayPrimaryScripts = Object.values(scripts);
  if (Object.keys(displayPrimaryScripts).length === 0) {
    return [];
  }
  const activitiesByType = getActivityCategoriesByActivityType(state);
  return displayPrimaryScripts.map((script) => {
    const productYear = getProductYearForScript(script);
    const { zones, id, 'update-time': lastUpdated, primary,
      'activity-type': type, 'activity-uuid': activityUuid } = script;
    return {
      id:  `${managementZonesTypes.APPLICATION}-${activityUuid}-${productYear}-${id}`,
      lastUpdated,
      primary,
      productYear,
      applicationActivity: activitiesByType[type].code,
      managementZonesType: managementZonesTypes.APPLICATION,
      scriptId: id,
      zones
    };
  });
};
